
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'prediction/expressDelivery'
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.快件预报接口')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`, },
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,}
                    ]
            },
             { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "batchNo",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.航空主单号')}`},
                {name: "palletList",type: "List<AirFreightPalletSaveDTO>",require: "Y",normal: "",describe: `${this.$t('onlineDoc.托盘列表')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.AirFreightPalletSaveDTO参数')}`,
              value:[
                {name: "palletNo",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.托盘号')}`},
                {name: "packageList",type: "List<AirFreightPackageSaveDTO>",require: "Y",normal: "",describe: `${this.$t('onlineDoc.包列表')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.AirFreightPackageSaveDTO参数')}`,
              value:[
                {name: "packageNo",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.包号')}`},
                {name: "packageWeight",type: "Double",require: "N",normal: "",describe: `${this.$t('onlineDoc.包重量')}`},
                {name: "sealPackageTime",type: "String",require: "Y",normal: "YYYY-MM-DD hh:mm:ss",describe: `${this.$t('onlineDoc.封包时间')}`},
                {name: "orderList",type: "List<AirFreightOrderSaveDTO>",require: "Y",normal: "",describe: `${this.$t('onlineDoc.订单列表')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.AirFreightOrderSaveDTO参数')}`,
              value:[
                {name: "waybillId",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号')}`},
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`,},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
                  ]
            }

        ],
        //请求示例
        requestCode: `Header：
                    apiAccount=292508153084379141
                    digest=bIN6a2l07XweEKRizSHS9g==
                    timestamp=1645775620879
                    Body：
                    bizContent="{'batchNo':'r4234234','palletList':[{'palletNo':'234234','packageList':[{'packageNo':'2342342','packageWeight':0,'sealPackageTime':'2022-07-21 15:24:56','orderList':[{'waybillId':'23423423'}]}]}]}"`,
        //返回示例
        responseCode: JSON.parse(`{
            "code": "1",
            "msg": "success"
        }
        `),

      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{'batchNo':'r4234234','palletList':[{'palletNo':'234234','packageList':[{'packageNo':'2342342','packageWeight':0,'sealPackageTime':'2022-07-21 15:24:56','orderList':[{'waybillId':'23423423'}]}]}]}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>